import { render, staticRenderFns } from "./ManagingPackage.vue?vue&type=template&id=df5524f2&scoped=true"
import script from "./ManagingPackage.vue?vue&type=script&lang=js"
export * from "./ManagingPackage.vue?vue&type=script&lang=js"
import style0 from "./ManagingPackage.vue?vue&type=style&index=0&id=df5524f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5524f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df5524f2')) {
      api.createRecord('df5524f2', component.options)
    } else {
      api.reload('df5524f2', component.options)
    }
    module.hot.accept("./ManagingPackage.vue?vue&type=template&id=df5524f2&scoped=true", function () {
      api.rerender('df5524f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/ManagingPackage.vue"
export default component.exports